<template>
  <WdsStack direction-row justify-space-between class="tw-w-full">
    <WdsStack justify-center align-center gap-sm>
      <WdsButtonGhost v-if="backLabel" :href="backUrl" secondary @click="emit('back')">
        <WdsStack align-center gap-sm>
          <WdsIcon name="arrow-left" :size="16" />
          {{ backLabel }}
        </WdsStack>
      </WdsButtonGhost>
      <template v-if="number">
        <WdsText v-if="backLabel" secondary>/</WdsText>
        <WdsText secondary>{{ `#${number}` }}</WdsText>
      </template>
    </WdsStack>
    <slot name="actions" />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsButtonGhost, WdsIcon, WdsStack, WdsText } from '@worksome/wds-components'

// Give a backUrl to link out, or listen for back to handle the click yourself.
defineProps<{
  backUrl?: string
  backLabel?: string
  number?: string | null
}>()

const emit = defineEmits<{ back: [] }>()
</script>
